import { ExtensionArtifactInvocationStatus } from "@redotech/cockroachdb-codegen/tables/extensions/extension-artifact-invocation-status";
import * as z from "zod";

export const ExtensionArtifactInvocationStatusSchema = z.nativeEnum(
  ExtensionArtifactInvocationStatus,
);

export const ExtensionArtifactInvocationPayloadStatusSchema = z.enum([
  "available",
  "expired",
  "unavailable",
  "failed",
]);

export const ExtensionArtifactInvocationSchema = z.object({
  id: z.string(),
  runId: z.string(),
  artifactId: z.string(),
  contractId: z.string(),
  targetId: z.string(),
  /** Friendly function name resolved from the host (experience/flow), or null. */
  functionName: z.string().nullable(),
  inputSelector: z.array(z.string()),
  sourceKind: z.string(),
  sourceId: z.string().nullable(),
  sourceContext: z.record(z.string(), z.unknown()),
  status: ExtensionArtifactInvocationStatusSchema,
  startedAt: z.date(),
  completedAt: z.date(),
  durationMs: z.number(),
  payloadStatus: ExtensionArtifactInvocationPayloadStatusSchema,
  payloadS3Key: z.string().nullable(),
  payloadSha256: z.string().nullable(),
  payloadBytes: z.number().nullable(),
  payloadExpiresAt: z.date().nullable(),
  payloadError: z.string().nullable(),
  errorName: z.string().nullable(),
  errorMessage: z.string().nullable(),
  createdAt: z.date(),
});

export const ExtensionArtifactInvocationCursorSchema = z.object({
  id: z.string(),
  startedAt: z.date(),
});

export type ExtensionArtifactInvocationCursor = z.infer<
  typeof ExtensionArtifactInvocationCursorSchema
>;

export const listExtensionArtifactInvocations = {
  name: "listExtensionArtifactInvocations" as const,
  input: z.object({
    artifactId: z.string().optional(),
    cursor: ExtensionArtifactInvocationCursorSchema.optional(),
    status: ExtensionArtifactInvocationStatusSchema.optional(),
    limit: z.number().int().positive().max(500).optional(),
  }),
  output: z.object({
    invocations: z.array(ExtensionArtifactInvocationSchema),
    nextCursor: ExtensionArtifactInvocationCursorSchema.nullable(),
  }),
};

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { ExtensionArtifactInvocationStatus } from "@redotech/cockroachdb-codegen/tables/extensions/extension-artifact-invocation-status";
